import { MonitorPrefEnumType, MyCertifiedPlant, PlantMonitoringEnumType } from "../telemetry";

export type DeviceType = 'inverter' | 'meter' | 'evcharge' | 'connext' | 'azzurro-hub' | 'enerclic' | 'heatPump' | 'PSC100' | 'no-zcs';
export type PhaseType = 'three-phase' | 'mono-phase';
export enum PhaseTypeCode {
  MonoPhase = 0,
  ThreePhase = 1,
}

export enum FotaStatus {
  Updating = '1',
}

export type InverterDeviceType = 'pv' | 'hybrid' | 'hybrid-3ph' | 'storage';

export interface Device {
  id: string; // Unique
  name: string; // Unique, optional
  type: DeviceType;
}

export interface Location {
  tz: number;
  coordinates: string;
}

export interface SystemConfig {
  latestTimezoneId?: string | null;
  timezoneEnd?: number | null;
  connextId?: string;
  azzurroHubId?: string;
  tigoId?: number | null;
  activeZone?: Location | null;
  temporaryZoneList: Location[];
  invertMeterSensor?: boolean;
}

export interface OperatorData {
  cmds?: string[];
  cmdObj?: { key: string; value: string }[];
}


export type SourceSystem = 'aws' | 'firebase' | 'sunflower';

export type SunflowerUser = {
    email: string;
    isOwner: boolean;
};

export interface System {
    uid?: string;
    connextSn?: string;
    configuration: SystemConfig;
    devices: Device[];
    img: string;
    name: string;
    source?: SourceSystem;
    aws?: Partial<MyCertifiedPlant>;
    monitorPref?: MonitorPrefEnumType;
    loggersType?: PlantMonitoringEnumType;
    users?: SunflowerUser[]; // Only in sunflower migration
}

export type Systems = System[];

export interface UserDocument {
  systems: Systems;
  version: number;
  operator?: OperatorData;
  warrantyExtensionConfirmed?: boolean;
}
